import validate from "../lib/validate";
class Comment{
	constructor(){
		this.validate = new validate("phone2");
		this.addEvents();
	}
	addEvents(){
		// boton datos del perfil
		let btnPerfil = window["btn-comment"];
		
		/* campos a validar */
		var data = {
			name: window["first_name2"],
			lastname: window["last_name2"],
			telephone: window["phone2"],
			email: window["email2"],
			comment: window["comment"]
		}

		/* si se requiere validar en tiempo real */
		this.validateInput(data);

		/* si solo se validan con el submit*/
		if ( btnPerfil ){	
			btnPerfil.addEventListener("click", (e) => {
				e.preventDefault();
				btnPerfil.disabled = true;			
				// ENVIAR FORM
				if (this.validateForm(data)){
					window["contactForm2"].submit();
				}else{
					btnPerfil.disabled = false;
				}
			
			}, false);
		}
	}

	/* valida input por input en tiempo real */
	validateInput(data) {
		/* valida email */
		data.email.addEventListener('input', (event) => {
		    let spanErrors = document.querySelector('#email2 + span.alertError');
		    if (this.validate.email(data.email.value).error) {
		        spanErrors.textContent = this.validate.email(data.email.value).msj
		        spanErrors.className = 'alertError activo';
		    } else {
		        spanErrors.innerHTML = ''; // Restablece el contenido del mensaje
				spanErrors.className = 'alertError';
		    }
		});

		/* valida nombre */		
		data.name.addEventListener('input', (event) => {
		    let spanErrors = document.querySelector('#first_name2 + span.alertError');
		    if (this.validate.nombres(data.name.value).error) {
		        spanErrors.textContent = this.validate.nombres(data.name.value).msj
		        spanErrors.className = 'alertError activo';
		    } else {
		        spanErrors.innerHTML = ''; // Restablece el contenido del mensaje
		        spanErrors.className = 'alertError';
		    }
		});

		/* valida apellido */
		data.lastname.addEventListener('input', (event) => {
		    let spanErrors = document.querySelector('#last_name2 + span.alertError');
		    if (this.validate.nombres(data.lastname.value).error) {
		        spanErrors.textContent = this.validate.nombres(data.lastname.value).msj
		        spanErrors.className = 'alertError activo';
		    } else {
		        spanErrors.innerHTML = ''; // Restablece el contenido del mensaje
		        spanErrors.className = 'alertError';
		    }
		});

		/* valida telefono */
		data.telephone.addEventListener('input', (event) => {
		    let spanErrors = document.querySelector('#phone2 + span.alertError');
		    if (this.validate.telephone(data.telephone.value).error) {
		        spanErrors.textContent = this.validate.telephone(data.telephone.value).msj
		        spanErrors.className = 'alertError activo';
		    } else {
		        spanErrors.innerHTML = ''; // Restablece el contenido del mensaje
		        spanErrors.className = 'alertError';
		    }
		});
		
		/* valida comentario */
		data.comment.addEventListener('input', (event) => {
		    let spanErrors = document.querySelector('#comment + span.alertError');
		    if (this.validate.requiere(data.comment.value).error) {
		        spanErrors.textContent = this.validate.requiere(data.comment.value).msj
		        spanErrors.className = 'alertError activo';
		    } else {
		        spanErrors.innerHTML = ''; // Restablece el contenido del mensaje
		        spanErrors.className = 'alertError';
		    }
		});

	}

	// valida todo el formulario
	validateForm(data) {
		let success = true;
		if (this.validate.nombres(data.name.value).error) {
			let spanErrors = document.querySelector('#first_name2 + span.alertError');
			spanErrors.textContent = this.validate.nombres(data.name.value).msj
			spanErrors.className = 'alertError activo';
			success = false;
			window["first_name2"].focus();
		}else if (this.validate.nombres(data.lastname.value).error) {
			let spanErrors = document.querySelector('#last_name2 + span.alertError');
			spanErrors.textContent = this.validate.nombres(data.lastname.value).msj
			spanErrors.className = 'alertError activo';
			success = false;
			window["last_name2"].focus();
		}else if (this.validate.email(data.email.value).error) {
			let spanErrors = document.querySelector('#email2 + span.alertError');
			spanErrors.textContent = this.validate.email(data.email.value).msj
		    spanErrors.className = 'alertError activo';
			success = false;
			window["email2"].focus();
		}else if (this.validate.telephone(data.telephone.value).error) {
		    let spanErrors = document.querySelector('#phone2 + span.alertError');
		    spanErrors.textContent = this.validate.telephone(data.telephone.value).msj
		    spanErrors.className = 'alertError activo';
		    success = false;
		    window["phone2"].focus();
		} else if (this.validate.requiere(data.comment.value).error) {
		    let spanErrors = document.querySelector('#comment + span.alertError');
		    spanErrors.textContent = this.validate.requiere(data.comment.value).msj
		    spanErrors.className = 'alertError activo';
		    success = false;
		    window["comment"].focus();
		}
		return (success);
	}

}

export default Comment;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/formComment.js